import con from '../../../connection';
var path = '/profiles';
var profiles = function (url) { return function (member_id) { return ({
    get: function () { return con.get(url + path + "/" + member_id, {}); },
    post: function (param) { return con.post(url + path + "/" + member_id, param); },
}); }; };
export default profiles;
